// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".holidayguru .hg-button{white-space:nowrap}.holidayguru .tw-h-12{height:3rem}.holidayguru .margin{margin-top:2.8125rem}", ""]);
// Exports
module.exports = exports;
